import { SvgIconBase, } from "./Base";


export const CheckCircleOutlined = (props: React.ComponentProps<typeof SvgIconBase>) => {
	return (
		<SvgIconBase {...props} width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-label="Check Circle Outlined" fill="none">
			<title>Check Circle Outlined</title>
			<circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
			<path d="M5 8.5L7 10.5L11 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIconBase>
	);
};




